import { lazy } from "react";
import { Route, Outlet } from "react-router-dom";
import { StudioProvider } from "@/contexts/StudioContext";

const StudioAccessGate = lazy(() => import("@/components/studio/StudioAccessGate"));
const StudioPageSwitcher = lazy(() => import("@/components/studio/StudioPageSwitcher"));

const ResumeBuilderPage = lazy(() => import("@/pages/studio/ResumeBuilderPage"));
const SkillAnalysisPage = lazy(() => import("@/pages/studio/SkillAnalysisPage"));
const JobMatchingPage = lazy(() => import("@/pages/studio/JobMatchingPage"));
const InterviewPrepPage = lazy(() => import("@/pages/studio/InterviewPrepPage"));
const ResumeUploadPage = lazy(() => import("@/pages/studio/ResumeUploadPage"));
const ResumeAnalysisPage = lazy(() => import("@/pages/studio/ResumeAnalysisPage"));
const CareerPathsPage = lazy(() => import("@/pages/studio/CareerPathsPage"));
const SkillGapsPage = lazy(() => import("@/pages/studio/SkillGapsPage"));
const LearningPage = lazy(() => import("@/pages/studio/LearningPage"));
const StudioHubPage = lazy(() => import("@/pages/studio/StudioHubPage"));

// Layout wrapper that provides StudioProvider for all studio routes
const StudioRouteLayout = () => (
  <StudioProvider>
    <Outlet />
  </StudioProvider>
);

export const studioRoutes = (
  <Route element={<StudioRouteLayout />}>
    <Route path="/studio" element={<StudioPageSwitcher />} />
    <Route path="/studio/upload" element={<StudioAccessGate><ResumeUploadPage /></StudioAccessGate>} />
    <Route path="/studio/analysis" element={<StudioAccessGate><ResumeAnalysisPage /></StudioAccessGate>} />
    <Route path="/studio/paths" element={<StudioAccessGate><CareerPathsPage /></StudioAccessGate>} />
    <Route path="/studio/skill-gaps" element={<StudioAccessGate><SkillGapsPage /></StudioAccessGate>} />
    <Route path="/studio/learning" element={<StudioAccessGate><LearningPage /></StudioAccessGate>} />
    <Route path="/studio/jobs" element={<StudioAccessGate><JobMatchingPage /></StudioAccessGate>} />
    <Route path="/studio/interview" element={<StudioAccessGate><InterviewPrepPage /></StudioAccessGate>} />
    <Route path="/studio/resume" element={<StudioAccessGate><ResumeBuilderPage /></StudioAccessGate>} />
    <Route path="/studio/skills" element={<StudioAccessGate><SkillAnalysisPage /></StudioAccessGate>} />
    <Route path="/studio/hub" element={<StudioAccessGate><StudioHubPage /></StudioAccessGate>} />
  </Route>
);
